<template>
  <b-container fluid class="page-premium-material">
    <b-row>
      <b-col class="header-nav-bar">
        <HeaderNavBar active-link="thrive_with_dropsmart" />
      </b-col>
    </b-row>
    <b-row class="body-padding">
      <b-col md="12" class="menu-left">
        <MenuLeftPremium
          v-on:navigate="navigate($event)"
          :customerInfo="customerInfo"
          @select-an-step="updateContent"
          :stepsInfoList="stepsInfoList"
          :stepQuery="stepQuery"
        />
      </b-col>

      <b-col class="content">
        <b-container style="margin-right: 0rem; margin-left: 0rem; ">
          <b-row>
            <PremiumContent
              :customerInfo="customerInfo"
              :stepsInfoList="stepsInfoList"
            />
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import HeaderNavBar from "@/components/private/my-account/HeaderNavBar.vue";
import MenuLeftPremium from "@/components/private/my-premium-material/MenuLeftPremium.vue";
import PremiumContent from "@/components/private/my-premium-material/PremiumContent.vue";

export default {
  title: "Dropsmart - My Premium Material",
  name: "MyPremiumMaterial",
  props: {
    page: {
      default: "",
      type: String,
    },
    stepQuery: {
      default: 1,
    },
  },
  mounted() {
    this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
    let target = this.page ? this.page : "Premium Material";
    console.log("navigating to " + target);
    this.navigate(target);
  },
  data() {
    return {
      content: null,
      customerInfo: null,
      stepsInfoList: [
        {
          stepNumber: 1,
          stepTitle: "Why one essential oil works",
          stepUrl: "https://www.youtube.com/embed/GGSz_nf-9SE?rel=0",
        },
        {
          stepNumber: 2,
          stepTitle:
            "How are essential oils the same & different at the same time?",
          stepUrl: "https://www.youtube.com/embed/oGbTUnUPp5c?rel=0",
        },
        {
          stepNumber: 3,
          stepTitle: "Why chemistry is your friend",
          stepUrl: "https://www.youtube.com/embed/aAqiATBpJr4?rel=0",
        },
        {
          stepNumber: 4,
          stepTitle:
            "Finding an appropriate substitute (for any essential oil)",
          stepUrl: "https://www.youtube.com/embed/BbACDaDndLM?rel=0",
        },
        {
          stepNumber: 5,
          stepTitle: "How to use the Search Button",
          stepUrl: "https://www.youtube.com/embed/c4dkHlmndi0?rel=0",
        },
        {
          stepNumber: 6,
          stepTitle: "Safe usage of unknown essential oils",
          stepUrl: "https://www.youtube.com/embed/O6icsPkIHlc?rel=0",
        },
        {
          stepNumber: 7,
          stepTitle: "Less oils = more control",
          stepUrl: "https://www.youtube.com/embed/qTKCvHPgw2g?rel=0",
        },
        {
          stepNumber: 8,
          stepTitle: "Cutting out the guesswork",
          stepUrl: "https://www.youtube.com/embed/5zySBJCAlj4?rel=0",
        },
        {
          stepNumber: 9,
          stepTitle: "Recognizing smell through color",
          stepUrl: "https://www.youtube.com/embed/2d4M2TIGMkM?rel=0",
        },
        {
          stepNumber: 10,
          stepTitle: "Picking your top 5 oils",
          stepUrl: "https://www.youtube.com/embed/tYP3XiOluis?rel=0",
        },
        {
          stepNumber: 11,
          stepTitle: "Conscious usage of the essential oils",
          stepUrl: "https://www.youtube.com/embed/RHQwDpDYTwo?rel=0",
        },
        {
          stepNumber: 12,
          stepTitle: "Debunking the universal diluting percentage myth",
          stepUrl: "https://www.youtube.com/embed/ErS_k2CMp-M?rel=0",
        },
        {
          stepNumber: 13,
          stepTitle: "Learning how to ask the right question",
          stepUrl: "https://www.youtube.com/embed/52tnVFZ3Pno?rel=0",
        },
        {
          stepNumber: 14,
          stepTitle: "Self-expression through Aromatherapy",
          stepUrl: "https://www.youtube.com/embed/QJjpxoSVT2I?rel=0",
        },
        {
          stepNumber: 15,
          stepTitle: "Experimentation without the consequences",
          stepUrl: "https://www.youtube.com/embed/ooFEkEOQdFI?rel=0",
        },
        {
          stepNumber: 16,
          stepTitle: "Conquering impostor syndrome",
          stepUrl: "https://www.youtube.com/embed/sh0jaCE3cSo?rel=0",
        },
        {
          stepNumber: 17,
          stepTitle: "Achieving ultimate literature independency",
          stepUrl: "https://www.youtube.com/embed/G8ZyYeT_BW0?rel=0",
        },
      ],
    };
  },
  computed: {
    contentComponent() {
      return this.content;
    },
  },
  components: {
    HeaderNavBar,
    MenuLeftPremium,
    PremiumContent,
  },
  methods: {
    navigate(routeName) {
      this.content = routeName;
    },
    contentUpdated() {
      this.customerInfo = JSON.parse(sessionStorage.getItem("customerInfo"));
      this.title = "I'm not a title";
    },
    updateContent() {
      this.title = "";
    },
  },
};
</script>
<style lang="scss">
$color: #000000;

html,
body {
  height: 100%;
  margin: 0 1rem;
}

//hidden scrollbar Firefox
html {
  scrollbar-width: none;
}

//hidden scrollbar Chrome, Safari and Opera
body::-webkit-scrollbar {
  display: none;
}

.page-premium-material {
  .header-nav-bar {
    padding-right: 0;
    padding-left: 0;
  }

  .body-padding {
    padding-top: 70px;
  }

  .menu-left {
    background-color: #ffffff;
    padding-bottom: 65px;
  }
  .content {
    background-color: #ffffff;
  }
}

.my-account {
  color: $color;
  margin-bottom: 30px;
  a {
    color: #509610;
    &:hover {
      color: $color;
    }
  }
}
@media screen and (max-width: 768px) {
}
@media screen and (min-width: 768px) {
  .container,
  .container-fluid {
    .menu-left {
      max-width: 390px;
    }
  }
}
@media screen and (max-width: 600px) {
  .page-premium-material {
    .body-padding {
      padding-top: 160px;
    }
  }
}
</style>
